import React from 'react'

const ListPageHeading = ({ children }) => {
  return (
    <h1 className='h2 mt-4 font-weight-light text-center' style={{ marginBottom: '2rem' }}>
      {children}
    </h1>
  )
}

export default ListPageHeading
